import { ref } from "vue";
import { defineStore } from "pinia";
import axios from "axios";
import { useSystemStore } from "@/stores/system";

export const useHttpStore = defineStore("http", () => {
  const systemStore = useSystemStore();
  const token = ref("");
  const showLoading = ref(false);
  const processing = ref(false);

  const apiAll = (promiseArray) => {
    return new Promise((resolve, reject) => {
      axios
        .all(promiseArray)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          console.log('http 1', error)
          reject(error);
        });
    });
  };

  const api = (method, url, parameters, options) => {
    var localShowLoading =
      options != undefined && options.showLoading != undefined
        ? options.showLoading
        : true;

    axios.defaults.baseURL = process.env.VITE_APIBASEURL ??  import.meta.env.VITE_APIBASEURL;
    axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
    axios.defaults.headers.common["Access-Control-Allow-Methods"] =
      "GET,PUT,POST,DELETE,PATCH,OPTIONS";
    axios.defaults.headers.common["Authorization"] = "Bearer " + token.value;

    if (method == "get") {
      const qParams = new URLSearchParams(parameters);
      url = url + "?" + qParams;
    }



    return new Promise((resolve, reject) => {
      showLoading.value = localShowLoading;

      axios[method](url, parameters, options)
        .then((res) => {
          processing.value = false;
          const defaultTimeOut = 10000;
          const flashTimeout = 3000;
          let timeout = defaultTimeOut;

          if (res.data.messages != undefined && res.data.messages.length > 0) {
            if (res.data.messages.length === 1 && res.data.messages[0].length <= 30) {
              timeout = flashTimeout;
            }
            if (res.data.success != undefined && res.data.success === true) {
              systemStore.showMessage(res.data.messages, {
                timeout: timeout,
                color: "info",
              });
            } else if (res.data.success != undefined && res.data.success === false) {
              systemStore.showMessage(res.data.messages, {
                timeout: timeout,
                color: "error",
              });
            }
          }

          resolve(res.data);
          // processing.value = false
          // showLoading.value = false

          setTimeout(() => {
            showLoading.value = false;
          }, 500);
        })
        .catch((error) => {

          setTimeout(() => {
            showLoading.value = false;
          }, 500);

          if (error.response == undefined) {
            // systemStore.showMessage(error.message, {
            //   timeout: 10000,
            //   color: "error",
            // });
          } else if (
            error.response != undefined &&
            error.response.status != "200"
          ) {
            systemStore.showMessage(
              "(" + error.response.status + ") " + error.response.data,
              { timeout: 10000, color: "error" }
            );
          }
          reject(error);
        });
    });
  };

  return {
    useHttpStore,
    showLoading,
    token,
    api,
    apiAll
  };
});
